export interface NavigationDataResponse {
  megaMenu: NavigationMenuItem[];
}

export interface NavigationMenuItem {
  target: string;
  url: string;
  navTitle: string;
  mobileLinkTitle: string;
  deepLink?: NavigationDeepLink;
  sideDeep?: NavigationDeepLink;
  sidePanel?: any[];
  children: NavigationChild[];
}

export interface NavigationDeepLink {
  navTitle: string;
  url: string;
  target: string;
  mobileLinkTitle?: string;
}

export interface NavigationChild {
  target: string;
  url: string;
  mobileLinkTitle: string;
  navTitle: string;
  itemType?: string;
  image?: NavigationImage;
  children?: NavigationChild[];
  subItems?: NavigationChild[];
}

export interface NavigationImage {
  fileReference: string;
}

export interface ExploreSapResponse {
  exploreSapLink: ExploreSapLink
}

export interface ExploreSapLink {
  title: string;
  subMenuRows: SubMenuRow[];
  displayTitle: string;
}

export interface SubMenuRow {
  subMenuLinkItems: SubMenuLinkItemEntry[];
}

export interface SubMenuLinkItemEntry {
  category: string;
  url: string;
  items: SubMenuLinkItem[];
  displayItemsAsCategoryLink: boolean;
}

export interface SubMenuLinkItem {
  title: string;
  url: string;
}

export const mockMainNavigationResponse: NavigationDataResponse = {
  'megaMenu': [
    {
      'target': '_self',
      'url': 'https://www.sap.com/products.html',
      'navTitle': 'Products',
      'mobileLinkTitle': 'Overview',
      'deepLink': {
        'navTitle': 'View all products A–Z',
        'url': 'https://www.sap.com/products/a-z.html',
        'target': '_self'
      },
      'sideDeep': {
        'target': '_self',
        'url': 'https://www.sap.com/products.html',
        'mobileLinkTitle': 'Spotlights',
        'navTitle': 'Products'
      },
      'children': [
        {
          'target': '_self',
          'url': 'https://www.sap.com/products/business-suite.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'SAP Business Suite',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/artificial-intelligence.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Artificial intelligence'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/data-cloud.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Data and analytics'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/erp.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Cloud ERP applications'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/technology-platform.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Technology platform'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/business-transformation-management.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Transformation management'
            }
          ]
        },
        {
          'target': '_self',
          'url': '',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Cloud ERP applications',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/financial-management.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Financial management'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/spend-management.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Spend management'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/scm.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Supply chain management'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/hcm.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Human capital management'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/crm.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Customer experience'
            }
          ]
        },
        {
          'target': '_self',
          'url': '',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'More SAP offerings',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/sustainability.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Sustainability management'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/business-network.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'SAP Business Network'
            }
          ]
        }
      ]
    },
    {
      'target': '_self',
      'url': 'https://www.sap.com/industries.html',
      'navTitle': 'Industries',
      'mobileLinkTitle': 'Overview',
      'deepLink': {
        'navTitle': 'View all industries',
        'url': 'https://www.sap.com/industries.html',
        'target': '_self'
      },
      'sideDeep': {
        'target': '_self',
        'url': 'https://www.sap.com/industries.html',
        'mobileLinkTitle': 'Spotlights',
        'navTitle': 'Industries'
      },
      'children': [
        {
          'target': '_self',
          'url': '',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Featured industries',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_self',
              'url': 'https://www.sap.com/industries/automotive.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Automotive'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/industries/consumer-products.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Consumer products'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/industries/industrial-manufacturing.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Industrial manufacturing'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/industries/mill-products.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Mill products'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/industries/professional-services.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Professional services'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/industries/retail.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Retail'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/industries/utilities.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Utilities'
            }
          ]
        }
      ]
    },
    {
      'target': '_self',
      'url': 'https://www.sap.com/services-support.html',
      'navTitle': 'Support',
      'mobileLinkTitle': 'Overview',
      'sideDeep': {
        'target': '_self',
        'url': 'https://www.sap.com/services-support.html',
        'mobileLinkTitle': 'Spotlights',
        'navTitle': 'Support'
      },
      'children': [
        {
          'target': '_self',
          'url': 'https://www.sap.com/services-support.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Services and support offerings',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_self',
              'url': 'https://www.sap.com/services-support/essential-support.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Foundational support'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/services-support/service-offerings.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Success plans and services '
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/services-support/premium-support.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Premium engagements'
            }
          ]
        },
        {
          'target': '_self',
          'url': 'https://support.sap.com/en/index.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Customer support portal',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_blank',
              'url': 'https://me.sap.com/getsupport',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Get support (SAP for Me login)'
            },
            {
              'target': '_self',
              'url': 'https://support.sap.com/en/my-support/knowledge-base.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Knowledge base'
            },
            {
              'target': '_self',
              'url': 'https://help.sap.com/',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Documentation (Help Portal)'
            },
            {
              'target': '_self',
              'url': 'https://support.sap.com/en/my-support/software-downloads.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Software downloads'
            },
            {
              'target': '_self',
              'url': 'https://support.sap.com/en/alm.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Application lifecycle management'
            },
            {
              'target': '_self',
              'url': 'https://support.sap.com/en/release-upgrade-maintenance/maintenance-information.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Maintenance information'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/products/business-network/suppliers/support.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'SAP Business Network for Suppliers'
            }
          ]
        }
      ]
    },
    {
      'target': '_self',
      'url': 'https://www.sap.com/training-certification.html',
      'navTitle': 'Learning',
      'mobileLinkTitle': 'Overview',
      'sideDeep': {
        'target': '_self',
        'url': 'https://www.sap.com/training-certification.html',
        'mobileLinkTitle': 'Spotlights',
        'navTitle': 'Learning'
      },
      'sidePanel': [],
      'children': [
        {
          'target': '_blank',
          'url': 'https://www.sap.com/training-certification.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Learning overview',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_self',
              'url': 'https://www.sap.com/training-certification/learning-hub.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': ' SAP Learning Hub'
            },
            {
              'target': '_blank',
              'url': 'https://training.sap.com/content/sap-learning-class-in-person-virtual',
              'mobileLinkTitle': 'Overview',
              'navTitle': ' SAP Learning Class'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/training-certification/sap-certification.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'SAP Certification'
            }
          ]
        }
      ]
    },
    {
      'target': '_self',
      'url': 'https://community.sap.com/',
      'navTitle': 'Community',
      'mobileLinkTitle': 'Overview',
      'sideDeep': {
        'target': '_self',
        'url': 'https://community.sap.com/',
        'mobileLinkTitle': 'Spotlights',
        'navTitle': 'Community'
      },
      'children': [
        {
          'target': '_self',
          'url': 'https://community.sap.com/',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Community overview',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_self',
              'url': 'https://community.sap.com/t5/products-and-technology/ct-p/products',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Products and technology'
            },
            {
              'target': '_self',
              'url': 'https://community.sap.com/t5/groups/ct-p/groups',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Groups'
            },
            {
              'target': '_self',
              'url': 'https://pages.community.sap.com/resources/partners',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Partners '
            },
            {
              'target': '_self',
              'url': 'https://pages.community.sap.com/topics',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Topics'
            },
            {
              'target': '_self',
              'url': 'https://community.sap.com/t5/events/ct-p/events',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Events'
            },
            {
              'target': '_self',
              'url': 'https://community.sap.com/t5/what-s-new/bg-p/whats-new',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'What’s new'
            },
            {
              'target': '_self',
              'url': 'https://community.sap.com/t5/help/faqpage',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Help'
            }
          ]
        }
      ]
    },
    {
      'target': '_self',
      'url': 'https://www.sap.com/partners.html',
      'navTitle': 'Partners',
      'mobileLinkTitle': 'Overview',
      'sideDeep': {
        'target': '_self',
        'url': 'https://www.sap.com/partners.html',
        'mobileLinkTitle': 'Spotlights',
        'navTitle': 'Partners'
      },
      'sidePanel': [],
      'children': [
        {
          'target': '_self',
          'url': 'https://www.sap.com/partners.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Partner overview',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_self',
              'url': 'https://www.sap.com/partners/find-partner-solutions.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Find partner solutions'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/partners/find.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Find SAP partners'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/partners/partner-program.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Become a partner'
            },
            {
              'target': '_self',
              'url': 'https://www.sap.com/partners/pinnacle-awards.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'SAP Pinnacle awards'
            }
          ]
        },
        {
          'target': '_self',
          'url': '',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Partner login',
          'image': {
            'fileReference': ''
          },
          'children': [
            {
              'target': '_blank',
              'url': 'https://partneredge.sap.com/en/welcome.html',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'SAP Partner Portal'
            },
            {
              'target': '_blank',
              'url': 'https://partnercockpit.store.sap.com',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'SAP Store Partner Cockpit'
            },
            {
              'target': '_blank',
              'url': 'https://solutionhub.store.sap.com/solution-hub',
              'mobileLinkTitle': 'Overview',
              'navTitle': 'Solution Hub'
            }
          ]
        }
      ]
    },
    {
      'target': '_self',
      'url': 'https://www.sap.com/about.html',
      'navTitle': 'About',
      'mobileLinkTitle': 'Overview',
      'sideDeep': {
        'target': '_self',
        'url': 'https://www.sap.com/about.html',
        'mobileLinkTitle': 'Spotlights',
        'navTitle': 'About'
      },
      'children': [
        {
          'target': '_self',
          'url': 'https://www.sap.com/about/company.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Company information',
          'image': {
            'fileReference': ''
          }
        },
        {
          'target': '_self',
          'url': 'https://jobs.sap.com/?utm_source\u003dCareerSite\u0026utm_campaign\u003dCorpSite_HD',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Careers',
          'image': {
            'fileReference': ''
          }
        },
        {
          'target': '_self',
          'url': 'https://www.sap.com/about/customer-stories.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Customer stories',
          'image': {
            'fileReference': ''
          }
        },
        {
          'target': '_self',
          'url': 'https://www.sap.com/events.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Events',
          'image': {
            'fileReference': ''
          }
        },
        {
          'target': '_self',
          'url': 'https://www.sap.com/investors/en.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'Investor relations',
          'image': {
            'fileReference': ''
          }
        },
        {
          'target': '_self',
          'url': 'https://news.sap.com/',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'News center',
          'image': {
            'fileReference': ''
          }
        },
        {
          'target': '_self',
          'url': 'https://www.sap.com/about/trust-center.html',
          'mobileLinkTitle': 'Overview',
          'navTitle': 'SAP Trust Center',
          'image': {
            'fileReference': ''
          }
        }
      ]
    }
  ]
}

export const mockExploreSapResponse: ExploreSapResponse = {
  'exploreSapLink': {
    'title': 'Explore SAP',
    'displayTitle': 'Explore all areas of SAP',
    'subMenuRows': [
      {
        'subMenuLinkItems': [
          {
            'category': 'Products',
            'url': 'https://www.sap.com/products.html',
            'items': [
              {
                'title': 'SAP Business Suite',
                'url': 'https://www.sap.com/products/business-suite.html'
              },
              {
                'title': 'Artificial intelligence',
                'url': 'https://www.sap.com/products/artificial-intelligence.html'
              },
              {
                'title': 'Data and analytics',
                'url': 'https://www.sap.com/products/data-cloud.html'
              },
              {
                'title': 'Cloud ERP applications',
                'url': 'https://www.sap.com/products/erp.html'
              },
              {
                'title': 'Technology platform',
                'url': 'https://www.sap.com/products/technology-platform.html'
              },
              {
                'title': 'Financial management',
                'url': 'https://www.sap.com/products/financial-management.html'
              },
              {
                'title': 'Spend management',
                'url': 'https://www.sap.com/products/spend-management.html'
              },
              {
                'title': 'Supply chain management',
                'url': 'https://www.sap.com/products/scm.html'
              },
              {
                'title': 'Human capital management',
                'url': 'https://www.sap.com/products/hcm.html'
              },
              {
                'title': 'Customer experience',
                'url': 'https://www.sap.com/products/crm.html'
              },
              {
                'title': 'SAP Business Network',
                'url': 'https://www.sap.com/products/business-network.html'
              },
              {
                'title': '-',
                'url': ''
              },
              {
                'title': 'View products A–Z',
                'url': 'https://www.sap.com/products/a-z.html'
              },
              {
                'title': 'View industries',
                'url': 'https://www.sap.com/industries.html'
              },
              {
                'title': 'Try SAP',
                'url': 'https://www.sap.com/products/try-sap.html'
              },
              {
                'title': '-',
                'url': ''
              },
              {
                'title': 'Partners',
                'url': 'https://www.sap.com/partners.html'
              },
              {
                'title': '-',
                'url': ''
              },
              {
                'title': 'Services',
                'url': 'https://www.sap.com/services-support.html'
              }
            ],
            'displayItemsAsCategoryLink': false
          },
          {
            'category': 'Learning and support',
            'url': '',
            'items': [
              {
                'title': 'Learning and certification',
                'url': 'https://learning.sap.com'
              },
              {
                'title': 'Support',
                'url': 'https://support.sap.com'
              },
              {
                'title': 'Documentation',
                'url': 'https://help.sap.com'
              },
              {
                'title': 'Community',
                'url': 'https://community.sap.com/'
              }
            ],
            'displayItemsAsCategoryLink': false
          },
          {
            'category': 'About',
            'url': '',
            'items': [
              {
                'title': 'Company information',
                'url': 'https://www.sap.com/about/company.html'
              },
              {
                'title': 'Careers',
                'url': 'https://jobs.sap.com/?utm_source\u003dCareerSite\u0026utm_campaign\u003dCorpSite_HD'
              },
              {
                'title': 'Customer stories',
                'url': 'https://www.sap.com/about/customer-stories.html'
              },
              {
                'title': 'Events',
                'url': 'https://www.sap.com/events.html'
              },
              {
                'title': 'Investor relations',
                'url': 'https://www.sap.com/investors/en.html'
              },
              {
                'title': 'News center',
                'url': 'https://news.sap.com/'
              },
              {
                'title': 'SAP Trust Center',
                'url': 'https://www.sap.com/about/trust-center.html'
              }
            ],
            'displayItemsAsCategoryLink': false
          }
        ]
      }
    ]
  }
}
